import * as React from 'react';
import _ from 'lodash';
import { BeatLoader } from 'react-spinners';
import { toastr } from 'react-redux-toastr';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { IReduxState } from 'src/reduxTypes';
import { IAuthState } from '../../Auth/store/types';
import { IProvider } from '../../../share/types/provider';
import { ProvidersService } from '../../../share/services/providers';
import { ProvidersForm } from './components/ProvidersForm';
import icmecLogo from '../../../images/logo-icmec-20th.png';
import webiqLogo from '../../../images/partners-hover/webiq.png';
import biometricaLogo from '../../../images/partners-hover/bio-big.png';
import bingLogo from '../../../images/partners-hover/bing.png';
import pimeyesLogo from '../../../images/partners-hover/pimeyes.jpg';
import tineyeLogo from '../../../images/partners-hover/tineye.png';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import "./providers.css";
import { RoutesModules } from 'src/modules/Routing/types';

export interface ICasesViewProps {
    auth: IAuthState;
};

export interface IProvidersState {
    providers: IProvider[];
    loading: boolean;
}

export class Providers extends React.Component<ICasesViewProps, IProvidersState> {
    constructor(props: ICasesViewProps) {
        super(props);
        const local = sessionStorage.getItem('icmec-providers')
        const data = local ? JSON.parse(local) : [];
        this.state = {
            loading: true,
            providers: data
        }
    }
    public componentDidMount() {
        this.loadData();
    }
    public loadData() {
        return ProvidersService.get().then((providers) => {
            sessionStorage.setItem('icmec-providers', JSON.stringify(providers))
            this.setState({ providers, loading: false })
        }).catch(() => {
            toastr.error('Error', 'There was a problem loading the provider information');
            this.setState({ loading: false });
        })
    }
    public setValue = (providerId, path: string, value: any) => {
        return new Promise<void>(resolve => {
            const state = { ...this.state };
            const index = state.providers.findIndex(provider => provider.providerId === providerId)
            _.set(state, `providers[${index}].${path}`, value);
            this.setState(state, () => resolve());
        })
    }
    public update = (provider: IProvider) => {
        this.setState({ loading: true });
        return ProvidersService.update(provider).then(() => {
            sessionStorage.setItem('icmec-providers', JSON.stringify(this.state.providers));
            ReactGA.event({
                category: 'Provider',
                action: `Updated ${provider.name} image provider settings`,
                label: 'Providers management'
            });
            this.setState({ loading: false });
        }).catch(() => {
            toastr.error('Error', 'There was a problem updating the provider information');
            this.setState({ loading: false })
        })
    }
    public render() {
        const { providers } = this.state;
        const logo = { icmec: icmecLogo, webiq: webiqLogo, biometrica: biometricaLogo, pimeyes: pimeyesLogo, bing: bingLogo, tineye: tineyeLogo }
        return (
            <div className={"margin-forms providers"}>
                <div className="col-12">
                    <div className="help-loader">
                        <BeatLoader loading={this.state.loading} />
                    </div>
                    <>
                        {
                            providers.map((provider) => (
                                <ProvidersForm
                                    update={this.update}
                                    key={provider.providerId}
                                    provider={provider}
                                    setValue={this.setValue}
                                    disabled={this.state.loading}
                                    logo={logo[(provider.name.replace(/ .*/, '') || "").toLowerCase()]}
                                    agencies={this.props.auth.agencies || []}
                                />
                            ))
                        }
                    </>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState) => ({
    auth: state.auth
});

export const AdminProviders = SidebarContainer(RoutesModules.ADMIN)(connect(mapStateToProps, null)(Providers));